import { Form } from 'react-bootstrap';

const Percent = ({
  label,
  name,
  value,
  onChange,
  className,
  labelClassName,
  inputClassName,
  placeholder,
}) => {
  const handleChange = (e) => {
    if (
      Number(e.target.value) < 0
      || (e.target.value.length > 1 && Number(e.target.value) <= 0)
      || Number(e.target.value[0]) <= 0
    ) {
      e.target.value = 0;
    }
    if (Number(e.target.value) > 100) {
      e.target.value = 100;
    }
    Number(e.target.value);
    onChange(e);
  };

  return (
    <div className={className}>
      {label && <Form.Label className={labelClassName}>{label}</Form.Label>}
      <div className="d-flex align-items-center">
        <div>
          <Form.Control
            name={name}
            type="number"
            value={value}
            id="inputPercent"
            className={inputClassName}
            onChange={handleChange}
            placeholder={placeholder}
          />
        </div>
        <h5 className="mb-0 ms-8">%</h5>
      </div>
    </div>
  );
};

export default Percent;
